import React from 'react';

const SinglePropertyNearby = ({ what_nearby = {} }) => {
  const nearbyEntries = Object.entries(what_nearby);

  return (
    <div className="wg-property single-property-nearby">
      <div className="wg-title text-11 fw-6 text-color-heading">
        What’s Nearby?
      </div>
      <p className="description text-color-default">
        Explore nearby amenities to precisely locate your property and identify surrounding conveniences,
        providing a comprehensive overview of the living environment and the property's convenience.
      </p>

      <div className=" box-nearby">
          <div className="box-single-column pe-5">
            {nearbyEntries.map(([title, value], index) => (
              <div key={index} className="item-nearby gap-2 justify-content-between">
                <span className="fw-7 text-4">{title}:</span>
                <span>{value}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SinglePropertyNearby;
